<button 
  class="sort-type-btn" 
  nbTooltip="صعودی - نزولی" 
  nbTooltipPlacement="top"
  [disabled]="loading" 
  (click)="toggle()">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.5 6.5L11 3L7.5 6.5"
      [attr.stroke]="upColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 3.53516V12.9998"
      [attr.stroke]="upColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.5 9.5L5 13L8.5 9.5"
      [attr.stroke]="downColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 12.4375V3"
      [attr.stroke]="downColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
